import platform from './node/index.js';

export {platform as default}



//////////////////
// WEBPACK FOOTER
// ./~/_axios@1.4.0@axios/lib/platform/index.js
// module id = 17
// module chunks = 1